import { TPAComponentProps } from '../../../types';
import { TabItem } from '../Tab/types';
import { OverflowBehavior, TabsAlignment, TabsVariant } from '../types';

export interface ScrollableTabsScrollPosition {
  scrollLeft: number;
  scrollRight: number;
}

export interface ScrollableTabsTabsUIRect {
  left: number;
  width: number;
}

export interface ScrollableTabsScrollButtons {
  left: number;
  right: number;
}

export interface ScrollableTabsProps extends TPAComponentProps {
  items: TabItem[];
  alignment: TabsAlignment;
  variant: TabsVariant;
  onScroll(event: React.UIEvent): void;
  onClickItem(index: number, e: React.BaseSyntheticEvent): void;
  activeTabIndex: number;
  animateIndicator?: boolean;
  scrollButtons: ScrollableTabsScrollButtons;
  rtl: boolean;
  'aria-label'?: string;
  'aria-labelledby'?: string;
  'aria-describedby'?: string;
  isTablist?: boolean;
  overflowBehavior: OverflowBehavior;
}

export interface ScrollableTabsState {
  selectedIndicatorRect: ScrollableTabsTabsUIRect;
  focusedTabIdx: number;
}
